/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StruttureResDto } from '../../models/strutture-res-dto';
import { UpdateStrutturaDto } from '../../models/update-struttura-dto';

export interface StruttureControllerUpdateStruttura$Params {
  idStruttura: number;
  body: UpdateStrutturaDto;
}

export function struttureControllerUpdateStruttura(
  http: HttpClient,
  rootUrl: string,
  params: StruttureControllerUpdateStruttura$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<StruttureResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    struttureControllerUpdateStruttura.PATH,
    'patch',
  );
  if (params) {
    rb.path('idStruttura', params.idStruttura, {});
    rb.body(params.body, 'application/json');
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StruttureResDto>;
      }),
    );
}

struttureControllerUpdateStruttura.PATH = '/admin/strutture/id/{idStruttura}';
